import React, { Component } from 'react';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';

class PasswordRecovery extends Component {
	constructor(props) {
		super(props);
		this.state = {
			code: this.props.match.params.code,
			codeResponse: '',
			newPassword: '',
			newPasswordRepeat: '',
			isLoading: false,
			changeResponse: '',
			showPreloader: false
		}
	}

	componentWillMount() {
		var self = this;
		Api.getRecoveryInfo(this.state.code, function(response) {
			self.setState({
				codeResponse: response.codeResponse
			}, function() {
				if(self.state.codeResponse !== 'Continue.') {
					window.location.replace('/');
				}
			});
		});
	}

	onChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	onSubmitPasswordChange = (event) => {
		var self = this;
		event.preventDefault();
		this.setState({
			isLoading: true,
			showPreloader: true,
			changeResponse: ''
		}, function() {
			Api.passwordChange(JSON.stringify({ newPassword: this.state.newPassword, newPasswordRepeat: this.state.newPasswordRepeat, code: this.state.code }), function(response) {
				self.setState({
					changeResponse: response.response,
					showPreloader: response.showPreloader,
				}, function() {
					if(response.errorCode === 1) {
						self.setState({
							isLoading: false
						});
					} else {
						setTimeout(function(){
							window.location.replace('/');
						}, 2000);
					}
				});
			});
		});
	}

    render() {
        return(
            <div className="home">
            	<div className="homeCtr br10 sh1 login passwordRecovery">
            		<h2 className="br10Top">Password Change</h2>
            		<div className="info">
            			<form onSubmit={this.onSubmitPasswordChange}>
							<input type="password" name="newPassword" className="input1 br5 anim1" placeholder="New password" onChange={this.onChange} />
							<input type="password" name="newPasswordRepeat" className="input1 br5 anim1" placeholder="Repeat new password" onChange={this.onChange} />
							<input type="submit" className="submit1 br5 anim1" value="Change my password" disabled={this.state.isLoading} />
							<p className="response">{this.state.changeResponse}</p>
							<img className="preloader" src={Preloader} alt="Fresenius Preloader" style={{display: (this.state.showPreloader ? 'block' : 'none')}} />
						</form>
            		</div>
            	</div>
            </div>
        );
    }
}

export default PasswordRecovery;


// WEBPACK FOOTER //
// ./src/components/PasswordRecovery.js